// Version : 0.0.1
// Author : NANDHAKUMAR
// LastEdit : NANDHAKUMAR
// Last Add : 'UNSED IMPORTS AND VARIABLES REMOVED'
// Modified Date : 04-08-2025
const CollectionActionTypes = {
	/** ***************** OFFICER LIST CENTERS  START *********************** */
	GET_OFFICER_LIST_CENTERS_START: 'get_officer_list_centers_start',
	GET_OFFICER_LIST_CENTERS_SUCCESS: 'get_officer_list_centers_success',
	GET_OFFICER_LIST_CENTERS_FAILURE: 'get_officer_list_centers_failure',
	GET_OFFICER_LIST_CENTERS_RESPONSE_RESET: 'get_officer_list_centers_response_reset',
	GET_OFFICER_LIST_CENTERS_RESPONSE_CHANGED: 'get_officer_list_centers_response_changed',
	/** ***************** OFFICER LIST CENTERS END *********************** */

	/** ***************** OFFICER LIST ARREAR CENTERS  START *********************** */
	GET_OFFICER_LIST_ARREAR_CENTERS_START: 'get_officer_list_arrear_centers_start',
	GET_OFFICER_LIST_ARREAR_CENTERS_SUCCESS: 'get_officer_list_arrear_centers_success',
	GET_OFFICER_LIST_ARREAR_CENTERS_FAILURE: 'get_officer_list_arrear_centers_failure',
	GET_OFFICER_LIST_ARREAR_CENTERS_RESPONSE_RESET:
		'get_officer_list_arrear_centers_response_reset',
	GET_OFFICER_LIST_ARREAR_CENTERS_RESPONSE_CHANGED:
		'get_officer_list_arrear_centers_response_changed',
	/** ***************** OFFICER LIST ARREAR CENTERS END *********************** */

	/** ***************** BRANCH COLLECTION USERS LIST  START *********************** */
	GET_BRANCH_COLLECTION_USERS_LIST_START: 'get_branch_collection_users_list_start',
	GET_BRANCH_COLLECTION_USERS_LIST_SUCCESS: 'get_branch_collection_users_list_success',
	GET_BRANCH_COLLECTION_USERS_LIST_FAILURE: 'get_branch_collection_users_list_failure',
	GET_BRANCH_COLLECTION_USERS_LIST_RESPONSE_RESET:
		'get_branch_collection_users_list_response_reset',
	GET_BRANCH_COLLECTION_USERS_LIST_RESPONSE_CHANGED:
		'get_branch_collection_users_list_response_changed',
	/** ***************** BRANCH COLLECTION USERS LIST END *********************** */

	/** ***************** CENTER LIST OFFICER COLLECTIONS  START *********************** */
	GET_CENTER_LIST_OFFICER_COLLECTIONS_START: 'get_center_list_officer_collections_start',
	GET_CENTER_LIST_OFFICER_COLLECTIONS_SUCCESS: 'get_center_list_officer_collections_success',
	GET_CENTER_LIST_OFFICER_COLLECTIONS_FAILURE: 'get_center_list_officer_collections_failure',
	GET_CENTER_LIST_OFFICER_COLLECTIONS_RESPONSE_RESET:
		'get_center_list_officer_collections_response_reset',
	GET_CENTER_LIST_OFFICER_COLLECTIONS_RESPONSE_CHANGED:
		'get_center_list_officer_collections_response_changed',
	/** ***************** CENTER LIST OFFICER COLLECTIONS END *********************** */

	/** ***************** BRANCH TODAY COLLECTION DETAILS  START *********************** */
	GET_BRANCH_TODAY_COLLECTION_DETAILS_START: 'get_branch_today_collection_details_start',
	GET_BRANCH_TODAY_COLLECTION_DETAILS_SUCCESS: 'get_branch_today_collection_details_success',
	GET_BRANCH_TODAY_COLLECTION_DETAILS_FAILURE: 'get_branch_today_collection_details_failure',
	GET_BRANCH_TODAY_COLLECTION_DETAILS_RESET: 'get_branch_today_collection_details_reset',
	GET_BRANCH_TODAY_COLLECTION_DETAILS_CHANGED: 'get_branch_today_collection_details_changed',
	/** ***************** BRANCH TODAY COLLECTION DETAILS END *********************** */

	/** ***************** BRANCH TODAY DEMAND MOVE TO ARREAR  START *********************** */
	GET_BRANCH_TODAY_DEMAND_MOVETOARREAR_LIST_START:
		'get_branch_today_demand_movetoarrear_list_start',
	GET_BRANCH_TODAY_DEMAND_MOVETOARREAR_LIST_SUCCESS:
		'get_branch_today_demand_movetoarrear_list_success',
	GET_BRANCH_TODAY_DEMAND_MOVETOARREAR_LIST_FAILURE:
		'get_branch_today_demand_movetoarrear_list_failure',
	GET_BRANCH_TODAY_DEMAND_MOVETOARREAR_LIST_RESET:
		'get_branch_today_demand_movetoarrear_list_reset',
	GET_BRANCH_TODAY_DEMAND_MOVETOARREAR_LIST_CHANGED:
		'get_branch_today_demand_movetoarrear_list_changed',
	/** ***************** BRANCH TODAY DEMAND MOVE TO ARREAR END *********************** */

	/** ***************** BRANCH TODAY COLLECTION YET TO APPROVE  START *********************** */
	GET_BRANCH_TODAY_COLLECTION_YET_TO_APPROVE_START:
		'get_branch_today_collection_yet_to_approve_start',
	GET_BRANCH_TODAY_COLLECTION_YET_TO_APPROVE_SUCCESS:
		'get_branch_today_collection_yet_to_approve_success',
	GET_BRANCH_TODAY_COLLECTION_YET_TO_APPROVE_FAILURE:
		'get_branch_today_collection_yet_to_approve_failure',
	GET_BRANCH_TODAY_COLLECTION_YET_TO_APPROVE_RESET:
		'get_branch_today_collection_yet_to_approve_reset',
	GET_BRANCH_TODAY_COLLECTION_YET_TO_APPROVE_CHANGED:
		'get_branch_today_collection_yet_to_approve_changed',
	GET_BRANCH_TODAY_COLLECTION_YET_TO_APPROVE_CHANGED_DATA:
		'get_branch_today_collection_yet_to_approve_changed_data',
	/** ***************** BRANCH TODAY COLLECTION YET TO APPROVE END *********************** */

	/** ***************** CENTER COLLECTION DENOMINATION DETAILS  START *********************** */
	GET_CENTER_COLLECTION_DENOMINATION_DETAILS_START:
		'get_center_collection_denomination_details_start',
	GET_CENTER_COLLECTION_DENOMINATION_DETAILS_SUCCESS:
		'get_center_collection_denomination_details_success',
	GET_CENTER_COLLECTION_DENOMINATION_DETAILS_FAILURE:
		'get_center_collection_denomination_details_failure',
	GET_CENTER_COLLECTION_DENOMINATION_DETAILS_RESET:
		'get_center_collection_denomination_details_reset',
	GET_CENTER_COLLECTION_DENOMINATION_DETAILS_CHANGED:
		'get_center_collection_denomination_details_changed',
	/** ***************** CENTER COLLECTION DENOMINATION DETAILS END *********************** */

	/** ***************** ATTENDANCE OFFICER COLLECTION  START *********************** */
	GET_ATTENDANCE_OFFICER_COLLECTION_START: 'get_attendance_officer_collection_start',
	GET_ATTENDANCE_OFFICER_COLLECTION_SUCCESS: 'get_attendance_officer_collection_success',
	GET_ATTENDANCE_OFFICER_COLLECTION_FAILURE: 'get_attendance_officer_collection_failure',
	GET_ATTENDANCE_OFFICER_COLLECTION_RESET: 'get_attendance_officer_collection_reset',
	GET_ATTENDANCE_OFFICER_COLLECTION_CHANGED: 'get_attendance_officer_collection_changed',
	/** ***************** ATTENDANCE OFFICER COLLECTION END *********************** */

	/** ***************** BRANCH CLOSED LOAN LIST  START *********************** */
	GET_BRANCH_CLOSED_LOAN_LIST_START: 'get_branch_closed_loan_list_start',
	GET_BRANCH_CLOSED_LOAN_LIST_SUCCESS: 'get_branch_closed_loan_list_success',
	GET_BRANCH_CLOSED_LOAN_LIST_FAILURE: 'get_branch_closed_loan_list_failure',
	GET_BRANCH_CLOSED_LOAN_LIST_RESET: 'get_branch_closed_loan_list_reset',
	GET_BRANCH_CLOSED_LOAN_LIST_CHANGED: 'get_branch_closed_loan_list_changed',
	/** ***************** BRANCH CLOSED LOAN LIST END *********************** */

	/** ***************** BRANCH COLLECTION FUNDER ALLOCATE EOD  START *********************** */
	GET_BRANCH_COLLECTION_FUNDER_ALLOCATE_EOD_START:
		'get_branch_collection_funder_allocate_eod_start',
	GET_BRANCH_COLLECTION_FUNDER_ALLOCATE_EOD_SUCCESS:
		'get_branch_collection_funder_allocate_eod_success',
	GET_BRANCH_COLLECTION_FUNDER_ALLOCATE_EOD_FAILURE:
		'get_branch_collection_funder_allocate_eod_failure',
	GET_BRANCH_COLLECTION_FUNDER_ALLOCATE_EOD_RESET:
		'get_branch_collection_funder_allocate_eod_reset',
	GET_BRANCH_COLLECTION_FUNDER_ALLOCATE_EOD_CHANGED:
		'get_branch_collection_funder_allocate_eod_changed',
	GET_BRANCH_COLLECTION_FUNDER_ALLOCATE_EOD_CHANGED_DATA:
		'get_branch_collection_funder_allocate_eod_changed_data',
	/** ***************** BRANCH COLLECTION FUNDER ALLOCATE EOD END *********************** */

	/** ***************** UPDATE LOANPAID PER MEMBER COLLECTION APPROVE  START *********************** */
	UPDATE_LOANPAID_PER_MEMBER_COLLECTION_APPROVE_START:
		'update_loanpaid_per_member_collection_approve_start',
	UPDATE_LOANPAID_PER_MEMBER_COLLECTION_APPROVE_SUCCESS:
		'update_loanpaid_per_member_collection_approve_success',
	UPDATE_LOANPAID_PER_MEMBER_COLLECTION_APPROVE_FAILURE:
		'update_loanpaid_per_member_collection_approve_failure',
	UPDATE_LOANPAID_PER_MEMBER_COLLECTION_APPROVE_RESPONSE_RESET:
		'update_loanpaid_per_member_collection_approve_response_reset',
	UPDATE_LOANPAID_PER_MEMBER_COLLECTION_APPROVE_CHANGED:
		'update_loanpaid_per_member_collection_approve_changed',
	/** ***************** UPDATE LOANPAID PER MEMBER COLLECTION APPROVE END *********************** */

	/** ***************** UPDATE LOANPAID OVERALL COLLECTION APPROVE  START *********************** */
	UPDATE_LOANPAID_OVERALL_COLLECTION_APPROVE_START:
		'update_loanpaid_overall_collection_approve_start',
	UPDATE_LOANPAID_OVERALL_COLLECTION_APPROVE_SUCCESS:
		'update_loanpaid_overall_collection_approve_success',
	UPDATE_LOANPAID_OVERALL_COLLECTION_APPROVE_FAILURE:
		'update_loanpaid_overall_collection_approve_failure',
	UPDATE_LOANPAID_OVERALL_COLLECTION_APPROVE_RESPONSE_RESET:
		'update_loanpaid_overall_collection_approve_response_reset',
	UPDATE_LOANPAID_OVERALL_COLLECTION_APPROVE_CHANGED:
		'update_loanpaid_overall_collection_approve_changed',
	/** ***************** UPDATE LOANPAID OVERALL COLLECTION APPROVE END *********************** */

	/** ***************** SECURITY CHECK PASSWORD VERIFY  START *********************** */
	SECURITY_CHECK_PASSWORD_VERIFY_START: 'security_check_password_verify_start',
	SECURITY_CHECK_PASSWORD_VERIFY_SUCCESS: 'security_check_password_verify_success',
	SECURITY_CHECK_PASSWORD_VERIFY_FAILURE: 'security_check_password_verify_failure',
	SECURITY_CHECK_PASSWORD_VERIFY_RESPONSE_RESET: 'security_check_password_verify_response_reset',
	SECURITY_CHECK_PASSWORD_VERIFY_CHANGED: 'security_check_password_verify_changed',
	/** ***************** SECURITY CHECK PASSWORD VERIFY END *********************** */

	/** ***************** REVERT ALLOCATE FOR EOD  START *********************** */
	REVERT_ALLOCATE_FOR_EOD_START: 'revert_allocate_for_eod_start',
	REVERT_ALLOCATE_FOR_EOD_SUCCESS: 'revert_allocate_for_eod_success',
	REVERT_ALLOCATE_FOR_EOD_FAILURE: 'revert_allocate_for_eod_failure',
	REVERT_ALLOCATE_FOR_EOD_RESPONSE_RESET: 'revert_allocate_for_eod_response_reset',
	REVERT_ALLOCATE_FOR_EOD_CHANGED: 'revert_allocate_for_eod_changed',
	/** ***************** REVERT ALLOCATE FOR EOD END *********************** */

	/** ***************** COMMON COLLECTION UPDATE  START *********************** */
	COMMON_COLLECTION_UPDATE_START: 'common_collection_update_start',
	COMMON_COLLECTION_UPDATE_SUCCESS: 'common_collection_update_success',
	COMMON_COLLECTION_UPDATE_FAILURE: 'common_collection_update_failure',
	COMMON_COLLECTION_UPDATE_RESPONSE_RESET: 'common_collection_update_response_reset',
	COMMON_COLLECTION_UPDATE_CHANGED: 'common_collection_update_changed',
	/** ***************** COMMON COLLECTION UPDATE END *********************** */

	/** ***************** CHECK BRANCH EOD EXIST  START *********************** */
	CHECK_BRANCH_EOD_EXIST_START: 'check_branch_eod_exist_start',
	CHECK_BRANCH_EOD_EXIST_SUCCESS: 'check_branch_eod_exist_success',
	CHECK_BRANCH_EOD_EXIST_FAILURE: 'check_branch_eod_exist_failure',
	CHECK_BRANCH_EOD_EXIST_RESPONSE_RESET: 'check_branch_eod_exist_response_reset',
	CHECK_BRANCH_EOD_EXIST_CHANGED: 'check_branch_eod_exist_changed',
	/** ***************** CHECK BRANCH EOD EXIST END *********************** */

	/** ***************** CHECK BRANCH EOD EXIST FOR DATE  START *********************** */
	CHECK_BRANCH_EOD_EXIST_FOR_DATE_START: 'check_branch_eod_exist_for_date_start',
	CHECK_BRANCH_EOD_EXIST_FOR_DATE_SUCCESS: 'check_branch_eod_exist_for_date_success',
	CHECK_BRANCH_EOD_EXIST_FOR_DATE_FAILURE: 'check_branch_eod_exist_for_date_failure',
	CHECK_BRANCH_EOD_EXIST_FOR_DATE_RESPONSE_RESET:
		'check_branch_eod_exist_for_date_response_reset',
	CHECK_BRANCH_EOD_EXIST_FOR_DATE_CHANGED: 'check_branch_eod_exist_for_date_changed',
	/** ***************** CHECK BRANCH EOD EXIST FOR DATE END *********************** */

	/** ***************** UPDATE LOANPAID OVERALL MOVE TO ARREAR  START *********************** */
	UPDATE_LOANPAID_OVERALL_MOVE_TO_ARREAR_START: 'update_loanpaid_overall_move_to_arrear_start',
	UPDATE_LOANPAID_OVERALL_MOVE_TO_ARREAR_SUCCESS:
		'update_loanpaid_overall_move_to_arrear_success',
	UPDATE_LOANPAID_OVERALL_MOVE_TO_ARREAR_FAILURE:
		'update_loanpaid_overall_move_to_arrear_failure',
	UPDATE_LOANPAID_OVERALL_MOVE_TO_ARREAR_RESPONSE_RESET:
		'update_loanpaid_overall_move_to_arrear_response_reset',
	UPDATE_LOANPAID_OVERALL_MOVE_TO_ARREAR_CHANGED:
		'update_loanpaid_overall_move_to_arrear_changed',
	/** ***************** UPDATE LOANPAID OVERALL MOVE TO ARREAR END *********************** */

	/** ***************** UPDATE OVERALL ACCRUED INTEREST ALLOCATE FOR EOD  START *********************** */
	UPDATE_OVERALL_ACCRUED_INTEREST_ALLOCATE_FOR_EOD_START:
		'update_overall_accrued_interest_allocate_for_eod_start',
	UPDATE_OVERALL_ACCRUED_INTEREST_ALLOCATE_FOR_EOD_SUCCESS:
		'update_overall_accrued_interest_allocate_for_eod_success',
	UPDATE_OVERALL_ACCRUED_INTEREST_ALLOCATE_FOR_EOD_FAILURE:
		'update_overall_accrued_interest_allocate_for_eod_failure',
	UPDATE_OVERALL_ACCRUED_INTEREST_ALLOCATE_FOR_EOD_RESPONSE_RESET:
		'update_overall_accrued_interest_allocate_for_eod_response_reset',
	UPDATE_OVERALL_ACCRUED_INTEREST_ALLOCATE_FOR_EOD_CHANGED:
		'update_overall_accrued_interest_allocate_for_eod_changed',
	/** ***************** UPDATE OVERALL ACCRUED INTEREST ALLOCATE FOR EOD END *********************** */

	/** ***************** UPDATE OVERALL ALLOCATE FOR EOD  START *********************** */
	UPDATE_OVERALL_ALLOCATE_FOR_EOD_START: 'update_overall_allocate_for_eod_start',
	UPDATE_OVERALL_ALLOCATE_FOR_EOD_SUCCESS: 'update_overall_allocate_for_eod_success',
	UPDATE_OVERALL_ALLOCATE_FOR_EOD_FAILURE: 'update_overall_allocate_for_eod_failure',
	UPDATE_OVERALL_ALLOCATE_FOR_EOD_RESPONSE_RESET:
		'update_overall_allocate_for_eod_response_reset',
	UPDATE_OVERALL_ALLOCATE_FOR_EOD_CHANGED: 'update_overall_allocate_for_eod_changed',
	/** ***************** UPDATE OVERALL ALLOCATE FOR EOD END *********************** */

	/******************** FETCH GOLD LOAN COLLECTION APPROVE LIST START ************************************* */
	FETCH_GOLD_LOAN_COLLECTION_APPROVE_LIST_START: 'fetch_gold_loan_collection_approve_list_start',
	FETCH_GOLD_LOAN_COLLECTION_APPROVE_LIST_SUCCESS:
		'fetch_gold_loan_collection_approve_list_success',
	FETCH_GOLD_LOAN_COLLECTION_APPROVE_LIST_FAILURE:
		'fetch_gold_loan_collection_approve_list_failure',
	FETCH_GOLD_LOAN_COLLECTION_APPROVE_LIST_RESPONSE_RESET:
		'fetch_gold_loan_collection_approve_list_response_reset',
	FETCH_GOLD_LOAN_COLLECTION_APPROVE_LIST_RESPONSE_CHANGED:
		'fetch_gold_loan_collection_approve_list_response_changed',
	/** ***************** FETCH GOLD LOAN COLLECTION APPROVE LIST END *********************** */

	/** ***************** FETCH SAVINGS COLLECTION APPROVE DETAILS  START *********************** */
	FETCH_SAVINGS_COLLECTION_APPROVE_DETAILS_START:
		'fetch_savings_collection_approve_details_start',
	FETCH_SAVINGS_COLLECTION_APPROVE_DETAILS_SUCCESS:
		'fetch_savings_collection_approve_details_success',
	FETCH_SAVINGS_COLLECTION_APPROVE_DETAILS_FAILURE:
		'fetch_savings_collection_approve_details_failure',
	FETCH_SAVINGS_COLLECTION_APPROVE_DETAILS_RESPONSE_RESET:
		'fetch_savings_collection_approve_details_response_reset',
	FETCH_SAVINGS_COLLECTION_APPROVE_DETAILS_RESPONSE_CHANGED:
		'fetch_savings_collection_approve_details_response_changed',
	/** ***************** FETCH SAVINGS COLLECTION APPROVE DETAILS END *********************** */

	/** ***************** UPDATE SAVINGS ALLOCATE FOR EOD  START *********************** */
	UPDATE_SAVINGS_ALLOCATE_FOR_EOD_START: 'update_savings_allocate_for_eod_start',
	UPDATE_SAVINGS_ALLOCATE_FOR_EOD_SUCCESS: 'update_savings_allocate_for_eod_success',
	UPDATE_SAVINGS_ALLOCATE_FOR_EOD_FAILURE: 'update_savings_allocate_for_eod_failure',
	UPDATE_SAVINGS_ALLOCATE_FOR_EOD_RESPONSE_RESET:
		'update_savings_allocate_for_eod_response_reset',
	UPDATE_SAVINGS_ALLOCATE_FOR_EOD_CHANGED: 'update_savings_allocate_for_eod_changed',
	/** ***************** UPDATE SAVINGS ALLOCATE FOR EOD END *********************** */

	/** ***************** FETCH SAVINGS COLLECTION APPROVE DETAILS  START *********************** */
	GET_SAVINGS_DENOMINATION_DETAILS_START: 'get_savings_denomination_details_start',
	GET_SAVINGS_DENOMINATION_DETAILS_SUCCESS: 'get_savings_denomination_details_success',
	GET_SAVINGS_DENOMINATION_DETAILS_FAILURE: 'get_savings_denomination_details_failure',
	GET_SAVINGS_DENOMINATION_DETAILS_RESPONSE_RESET:
		'get_savings_denomination_details_response_reset',
	GET_SAVINGS_DENOMINATION_DETAILS_RESPONSE_CHANGED:
		'get_savings_denomination_details_response_changed',
	/** ***************** FETCH SAVINGS COLLECTION APPROVE DETAILS END *********************** */

	/***************** UPDATE GOLD LOAN COLLECTION APPROVE START ****************************** */
	UPDATE_GOLD_LOAN_COLLECTION_APPROVE_START: 'update_gold_loan_collection_approve_start',
	UPDATE_GOLD_LOAN_COLLECTION_APPROVE_SUCCESS: 'update_gold_loan_collection_approve_success',
	UPDATE_GOLD_LOAN_COLLECTION_APPROVE_FAILURE: 'update_gold_loan_collection_approve_failure',
	UPDATE_GOLD_LOAN_COLLECTION_APPROVE_RESPONSE_RESET:
		'update_gold_loan_collection_approve_response_reset',
	UPDATE_GOLD_LOAN_COLLECTION_APPROVE_RESPONSE_CHANGED:
		'update_gold_loan_collection_approve_response_changed',
	/** ***************** UPDATE GOLD LOAN COLLECTION APPROVE END *********************** */

	/***************** UPDATE SAVINGS COLLECTION APPROVE START ****************************** */
	UPDATE_SAVINGS_COLLECTION_APPROVE_START: 'update_savings_collection_approve_start',
	UPDATE_SAVINGS_COLLECTION_APPROVE_SUCCESS: 'update_savings_collection_approve_success',
	UPDATE_SAVINGS_COLLECTION_APPROVE_FAILURE: 'update_savings_collection_approve_failure',
	UPDATE_SAVINGS_COLLECTION_APPROVE_RESPONSE_RESET:
		'update_savings_collection_approve_response_reset',
	UPDATE_SAVINGS_COLLECTION_APPROVE_RESPONSE_CHANGED:
		'update_savings_collection_approve_response_changed',
	/** ***************** UPDATE SAVINGS COLLECTION APPROVE END *********************** */

	/** ***************** SUBMIT APPROVE STAFF TRAVEL DETAILS START *********************** */
	SUBMIT_APPROVE_STAFF_TRAVEL_DETAILS_START: 'submit_approve_staff_travel_details_start',
	SUBMIT_APPROVE_STAFF_TRAVEL_DETAILS_SUCCESS: 'submit_approve_staff_travel_details_success',
	SUBMIT_APPROVE_STAFF_TRAVEL_DETAILS_FAILURE: 'submit_approve_staff_travel_details_failure',
	SUBMIT_APPROVE_STAFF_TRAVEL_DETAILS_RESPONSE_RESET:
		'submit_approve_staff_travel_details_response_reset',
	SUBMIT_APPROVE_STAFF_TRAVEL_DETAILS_RESPONSE_CHANGED:
		'submit_approve_staff_travel_details_response_changed',
	/** ***************** SUBMIT APPROVE STAFF TRAVEL DETAILS END *********************** */
};

export default CollectionActionTypes;
